import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__Error_module_js_e77d6009__ from "./Error.module.js";
function ErrorMessage({ errorMessage }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("p", {
        className: __WEBPACK_EXTERNAL_MODULE__Error_module_js_e77d6009__["default"].error,
        children: errorMessage
    });
}
const Error_rslib_entry_ = ErrorMessage;
export { Error_rslib_entry_ as default };

//# sourceMappingURL=Error.js.map